import { render } from "./MagentoOrder.vue?vue&type=template&id=689b4532"
import script from "./MagentoOrder.vue?vue&type=script&lang=js"
export * from "./MagentoOrder.vue?vue&type=script&lang=js"

import "./MagentoOrder.vue?vue&type=style&index=0&id=689b4532&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__